import TypingBox  from './components/TypingBox'
import {GlobalStyles} from './Styles/global'
import Header from './components/Header'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css";
import Footer from './components/Footer';
import { useContext } from 'react';
import { ThemeContext } from './Context/ThemeContext';
import { ThemeProvider } from 'styled-components';
import { Routes,Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Userpage from './pages/Userpage';


function App ()
{
 const {theme} =useContext(ThemeContext)
    return(
      
      <ThemeProvider theme={theme}>
      <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      />
      <div className="canvas">
      <GlobalStyles />
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/user' element={<Userpage />} />
      </Routes>
      </div>
      </ThemeProvider>
     
    ) 
}
export default App
